<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="form-panel__thanks form-panel">
    <h2>{{ formConfig.form_submitted_heading }}</h2>
    <div
      v-if="formConfig.form_submitted_tagline"
      class="form-panel__thanks__tagline"
      v-html="formConfig.form_submitted_tagline"
    />
    <div v-if="isLTT">
      <div class="text-h6 font-weight-bold mb-3">
        {{ $t('action.panels.THANKS.shareWithYourFriendsMessage', locale, { stepNumber }) }}
      </div>
      <div v-if="!isSingleRepLTT" class="mb-10">
        <div class="mb-3">
          {{ $t('action.panels.THANKS.notDoneYet', locale) }}
        </div>
        <v-btn
          color="secondary"
          small
          outlined
          @click="$store.dispatch('actionForm/resetLttWorkflow')"
        >
          <v-icon>{{ icons.mdiArrowLeftBoldCircleOutline }}</v-icon>
          &nbsp;
          {{ $t('action.panels.THANKS.buttons.chooseAnother.label', locale) }}
        </v-btn>
      </div>
    </div>
    <v-btn
      :href="formConfig.facebook_share_url"
      target="_blank"
      color="facebook-blue"
      class="text-uppercase"
      large
    >
      {{ formConfig.facebook_share_label }}
    </v-btn>
    <v-btn
      v-if="formConfig.bluesky_share_url"
      :href="formConfig.bluesky_share_url"
      target="_blank"
      color="bluesky-blue"
      class="text-uppercase"
      large
    >
      {{ formConfig.bluesky_share_label }}
    </v-btn>

    <v-btn
      v-if="formConfig.whatsapp_share_url"
      :href="formConfig.whatsapp_share_url"
      target="_blank"
      color="whatsapp-green"
      class="text-uppercase"
      large
    >
      {{ formConfig.whatsapp_share_label }}
    </v-btn>
    <v-btn
      v-if="formConfig.email_share_url && isMemberGenerated"
      :href="formConfig.email_share_url"
      target="_blank"
      color="primary"
      class="text-uppercase"
      large
    >
      {{ formConfig.email_share_label }}
    </v-btn>
    <div v-if="isMemberGenerated" class="form-panel__thanks__member-incentive">
      <div class="form-panel__thanks__member-incentive__text">
        {{ formConfig.form_submitted_petition_created_incentive }}
      </div>
      <v-btn :href="formConfig.signup_url" color="primary" large>
        {{ formConfig.form_submitted_start_your_own_campaign_label }}
      </v-btn>
    </div>
    <div class="mt-4">
      <copy-button />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { mdiArrowLeftBoldCircleOutline } from '@mdi/js'
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../utils/tracking'
import CopyButton from '../ui/CopyButton'

export default {
  name: 'PanelThanks',
  components: { CopyButton },
  data: () => ({
    EVENT_CATEGORIES,
    icons: {
      mdiArrowLeftBoldCircleOutline
    }
  }),
  computed: {
    stepNumber() {
      return this.isSingleRepLTT ? 3 : 4
    },
    ...mapState('actionForm', ['locale', 'formConfig', 'actionId', 'formData']),
    ...mapGetters('actionForm', ['isLTT', 'isMemberGenerated', 'isSingleRepLTT'])
  },
  mounted() {
    if (this.formData) {
      let cookieValue = null
      let name = 'csrftoken'
      if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim()
          if (cookie.substring(0, name.length + 1) === name + '=') {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
            break
          }
        }
      }
      var conversionType = ''
      if (this.formData && this.formData.user_gdpr_opt === 'NO') {
        conversionType = 'lead'
      } else {
        conversionType = 'complete_registration'
      }

      var data = {
        event_name: conversionType,
        action_source: 'website',
        campaign_name: 'All Out'
      }
      console.log(data)
      console.log('form data', this.formData)

      // Send data to the Meta Conversion API
      fetch(`/meta/meta-conversion-api/${conversionType}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': cookieValue
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(data => {
          console.log('Success:', data)
        })
        .catch(error => {
          console.error('Error:', error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_panels-common.scss';
</style>
